import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { createStyles } from '@material-ui/core/styles';
import { FontIcon, Text, Button, ButtonVariants, withBaseProps, } from '@topconagriculture/react-components';
import * as React from 'react';
import { withAuth0 } from '../../hocs';
import { compose, withHandlers } from 'recompose';
const styles = (theme) => createStyles({
    goToStartingPageButton: {
        marginTop: theme.space.margin.default,
        maxHeight: 50,
    },
    modalWrapper: {
        overflowY: 'auto',
        borderRadius: theme.common.borderRadius.default,
        maxWidth: '90%',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: `0 ${theme.space.padding.default}px`,
    },
    textLayout: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginLeft: theme.space.margin.default,
    },
    textTitle: {
        display: 'block',
        marginBottom: theme.space.margin.small,
    },
    infoIcon: {
        marginTop: theme.space.margin.default - 5,
    },
});
const ImpersonateExpiredModal = (props) => {
    const { classes, auth, goToStartingPage, t, theme } = props;
    return auth.isImpersonateExpired ? (React.createElement(Dialog, { open: auth.isImpersonateExpired, classes: { paper: classes.modalWrapper }, disableEnforceFocus: true },
        React.createElement(DialogContent, { className: classes.modalContent },
            React.createElement("div", { className: classes.textContainer },
                React.createElement(FontIcon, { iconName: "warning", size: 50, color: theme.color.error.main, className: classes.infoIcon }),
                React.createElement("div", { className: classes.textLayout },
                    React.createElement(Text, { size: 18, bold: true, className: classes.textTitle }, t('common:impersonate:expired')),
                    React.createElement(Text, null, t('common:impersonate:please_renew')))),
            React.createElement(Button, { testId: "go-to-starting-page", className: classes.goToStartingPageButton, onClick: goToStartingPage, label: t('common:impersonate:go_to_starting_page'), iconSize: 30, role: ButtonVariants.primary })))) : null;
};
export default compose(withBaseProps({ styles }), withAuth0, withHandlers({
    goToStartingPage: ({ auth }) => () => {
        auth.stopImpersonating();
    },
}))(ImpersonateExpiredModal);
//# sourceMappingURL=ImpersonateExpiredModal.js.map